const graphColors = (): string[] => {
  // get css variables
  var style = getComputedStyle(document.body);
  const primaryColor = style.getPropertyValue('--primary-color') || '#dc1964';
  const secondaryColor = style.getPropertyValue('--secondary-color') || '#00B496';

  return [secondaryColor, primaryColor, '#232D64'];
};

export { graphColors };
